import { CapoPlugin } from "/opt/buildhome/repo/node_modules/.pnpm/@unhead+vue@1.9.14_vue@3.4.31_typescript@5.5.2_/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];